import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const Footer: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div id="contact" className="section-footer">
            <div className="padding-global">
                <div className="container-large">
                    <div className="footer-component">
                        <div className="w-layout-grid footer-grid footer-grid--4col">
                            {/* Brand Column */}
                            <div className="footer-left-content">
                                <a href="/" aria-current="page" className="footer-brand-logo-wrapper w-inline-block w--current" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <h2 className="heading-style-h3 text-color-white" style={{ margin: 0 }}>{t('footer.brandName')}</h2>
                                </a>
                                <div className="padding-bottom padding-small"></div>
                                <p className="footer-text" style={{ whiteSpace: 'pre-line' }}>
                                    {t('footer.tagline')}
                                </p>
                                <div className="padding-bottom padding-xxsmall"></div>
                                <LanguageSelector />
                            </div>

                            {/* Products Column */}
                            <div className="footer-link-menu-wrapper">
                                <h5 className="heading-style-h5 text-color-white">{t('footer.product.title')}</h5>
                                <div className="footer-menu-link">
                                    <a href="/sproutly" className="footer-link">
                                        {t('footer.product.sproutly')}
                                    </a>
                                </div>
                            </div>

                            {/* Resources Column */}
                            <div className="footer-link-menu-wrapper">
                                <h5 className="heading-style-h5 text-color-white">{t('footer.resources.title')}</h5>
                                <div className="footer-menu-link">
                                    <a href="/blog" className="footer-link">{t('footer.resources.blog')}</a>
                                    <a href="/support" className="footer-link">{t('footer.resources.support')}</a>
                                </div>
                            </div>

                            {/* Legal Column */}
                            <div className="footer-link-menu-wrapper">
                                <h5 className="heading-style-h5 text-color-white">{t('footer.legal.title')}</h5>
                                <div className="footer-menu-link">
                                    <a href="/terms-of-service" className="footer-link">{t('footer.legal.terms')}</a>
                                    <a href="/privacy-policy" className="footer-link">{t('footer.legal.privacy')}</a>
                                </div>
                            </div>
                        </div>
                        <div className="padding-bottom padding-large"></div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom-content">
                <div className="footer-text">
                    {t('footer.copyright')}
                </div>
            </div>
        </div>
    );
};

export default Footer;
